import { render, staticRenderFns } from "./RawMaterialAllBatchList.vue?vue&type=template&id=510777f8&scoped=true&"
import script from "./RawMaterialAllBatchList.vue?vue&type=script&lang=js&"
export * from "./RawMaterialAllBatchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510777f8",
  null
  
)

export default component.exports